<template>
  <div class="content" v-loading.fullscreen.lock="loading">
    <!-- <base-header class="pb-6">
      <div class="row align-items-center py-2">
        <div class="col-lg-6 col-7"></div>
      </div>
    </base-header> -->
    <div class="notification-admin-wrap" v-if="editor === 'super-admin' || editor === 'sub-admin'">
      <div>
        <!-- <div class="dash-header mb-4">
            <h2 class="text-default m-0 d-flex">Notifications Management <img data-v-2131a5ef="" src="/signup-img/fire.svg" alt=""></h2>
        </div> -->
        <card class="no-border-card" footer-classes="pt-1">
            <div class="row  align-items-center mb-2">
            <div class="col-lg-6 dash-header">
                <h2 class="mb-0">Notifications Management </h2>
             </div>

              <div class="col-lg-6 col-md-6 text-right">
                <base-button type="primary" outline="true" v-on:click="resetFilters()"
                  ><i class="fa fa-refresh" aria-hidden="true"></i> Clear
                  Filters</base-button
                >
                <base-button v-if="canCreate" type="primary"  @click.prevent="createNotification"
                  ><i class="fa fa-plus" aria-hidden="true"></i> New
                  Notifications</base-button
                >
              </div>
            </div>
          <div>
            <div
              class="row d-flex justify-content-center justify-content-sm-between flex-wrap mb-4"
            >
              <div class="col-md-3 search-style">
                <label class="form-control-label">Search:</label>
                <base-input
                  v-model="searchQuery"
                  prepend-icon="fas fa-search"
                  placeholder="Search..."
                >
                </base-input>
              </div>

            </div>
            <div class="user-eltable vediotable table-style-fancy border overflow-hidden">
              <el-table
                :data="tableData"
                stripe
                highlight-current-row
                row-key="id"
                role="table"
                class="tourGrid"
                header-row-class-name="thead-light custom-thead-light"
              >


                <el-table-column min-width="100px" label="Role" class-name="left-align">
                  <template slot-scope="props">
                    <span>{{ props.row.role === 'company_admin' ? 'Company Admin' : (props.row.role === 'manager' ? 'Manager' : 'Employee') }}</span>
                  </template>
                </el-table-column>
                <el-table-column min-width="200px" label="Message" class-name="center-align">
                  <template slot-scope="props">
                    <span ref="copyUrl">{{ props.row.message }}</span>
                  </template>
                </el-table-column>
                <el-table-column min-width="130px" label="Date">
                  <template slot-scope="props">
                    <!-- <span ref="copyUrl">{{ props.row.created_at }}</span> -->
                  <span>{{ formatDate(props.row.created_at) }}</span>
                  </template>
                </el-table-column>

                <el-table-column min-width="140px" label="Action" class="float-right">
                  <template slot-scope="props">
                    <div class="actions-container">
                    <el-tooltip  v-if="canEdit" content="Edit" placement="top">
                      <base-button
                        @click.native="handleEdit(props.row.id)"
                        class="edit"
                        type=""
                        size="sm"
                        icon
                        data-toggle="tooltip"
                        data-original-title="Edit"
                      >

                      <!-- <img width="17" src="/img/icons/common/edit.svg" alt=""/> -->
                      <img class="ico-edit"  src="/img/icons/common/edit.svg" alt=""/>
                        <!-- <i class="text-default fa fa-pencil-square-o"></i> -->
                      </base-button>
                    </el-tooltip>
                    <el-tooltip v-if="canDelete" content="Delete" placement="top">
                      <base-button
                        @click.native="handleDelete(props.row.id)"
                        class="delete"
                        type=""
                        size="sm"
                        icon
                        data-toggle="tooltip"
                        data-original-title="Delete"
                      >
                      <!-- <img width="14" src="/img/icons/common/delete-icon.svg" alt=""/> -->
                        <!-- <i class="text-danger fas fa-trash"></i> -->
                        <img class="ico-del" src="/img/icons/common/delete-icon.svg" alt=""/>
                      </base-button>
                    </el-tooltip>
                  </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
            <!-- <div slot="footer" class="d-flex justify-content-end">
                <nav v-if="pagination && tableData.length > 0">
                    <div class="row">
                        <div class="col-md-12">
                            <ul
                                class="pagination custompagination justify-content-end align-items-center">
                                <p class="p-0 m-0 mr-2">
                                    Showing {{ tableData.length }} of {{ totalData }} entries
                                </p>
                                <li class="page-item" :class="{ disabled: currentPage === 1 }">
                                    <a class="page-link" href="#" @click.prevent="changePage(currentPage - 1)">
                                        <i class="fa fa-caret-left"></i>
                                    </a>
                                </li>
                                <li v-for="(page, index) in pagesNumber" class="page-item" :class="{ active: page == currentPage }" v-bind:key="index">
                                    <a href="javascript:void(0)" @click.prevent="changePage(page)" class="page-link">{{ page }}</a>
                                </li>
                                <li class="page-item" :class="{ disabled: currentPage === last_page}">
                                    <a class="page-link" href="#" @click.prevent="changePage(currentPage + 1)">
                                        <i class="fa fa-caret-right"></i>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </nav>
            </div> -->
        </card>
      </div>
    </div>
    <!-- View-only notifications for Company Admin, Manager, and Employee -->
    <div class="notification-view-wrap" v-if="editor === 'company' || editor === 'manager' || editor === 'employee'">
      <div>
        <card class="no-border-card" footer-classes="pt-1">
            <div class="row  align-items-center mb-2">
            <div class="col-lg-6 dash-header">
                <h2 class="mb-0">Notifications</h2>
             </div>

              <div class="col-lg-6 col-md-6 text-right">
                <base-button type="primary" outline="true" v-on:click="resetFilters()"
                  ><i class="fa fa-refresh" aria-hidden="true"></i> Clear
                  Filters</base-button
                >
              </div>
            </div>
          <div>
            <div
              class="row d-flex justify-content-center justify-content-sm-between flex-wrap mb-4"
            >
              <div class="col-md-3 search-style">
                <label class="form-control-label">Search:</label>
                <base-input
                  v-model="searchQuery"
                  prepend-icon="fas fa-search"
                  placeholder="Search..."
                >
                </base-input>
              </div>

            </div>
            <div class="user-eltable vediotable table-style-fancy border overflow-hidden">
              <el-table
                :data="tableData"
                stripe
                highlight-current-row
                row-key="id"
                role="table"
                class="tourGrid"
                header-row-class-name="thead-light custom-thead-light"
              >


                <el-table-column min-width="100px" label="Role" class-name="left-align">
                  <template slot-scope="props">
                    <span>{{ props.row.role === 'company_admin' ? 'Company Admin' : (props.row.role === 'manager' ? 'Manager' : 'Employee') }}</span>
                  </template>
                </el-table-column>
                <el-table-column min-width="200px" label="Message" class-name="center-align">
                  <template slot-scope="props">
                    <span ref="copyUrl">{{ props.row.message }}</span>
                  </template>
                </el-table-column>
                <el-table-column min-width="130px" label="Date">
                  <template slot-scope="props">
                    <span>{{ formatDate(props.row.created_at) }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Sortable from "sortablejs";
import { Table, TableColumn, Select, Option } from "element-ui";
import serverSidePaginationMixin from "../Tables/PaginatedTables/serverSidePaginationMixin";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
let timeout = null;
export default {
  mixins: [serverSidePaginationMixin],
  components: {
    Sortable,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  data() {
    return {
      tempUrl: "",
      loading: false,
      perPage: 10,
      currentPage: 1,
      sortBy: "title",
      sortDesc: false,
      viewCertificateModal: false,
      title: "",
      filters: {
        videoStatus: "Active",
        videoType:"Public"
      },
      selectedRows: [],
      tableData: [],
      searchQuery: "",
      duplicate: false,
      hot_user: "",
      hot_token: "",
      config: "",
      videos: [],
      timer: null,
      currentIndex: 0,
      editor: "",
      item_id: 0,
      type: [
        {
          label: "Public",
          value: "Public"
        },
        {
          label: "Private",
          value: "Private"
        },
        {
          label: "All Types",
          value: ""
        }
      ],
      status: [
        {
          label: "Active",
          value: "Active"
        },
        {
          label: "Inactive",
          value: "Inactive"
        },
        {
          label: "Show All Tour",
          value: ""
        }
      ],
      canCreate:false,
      canEdit:false,
      canDelete:false,

    };
  },
  watch: {
    searchQuery: function() {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        this.fetchData();
      }, 300);
    }
  },
  created: function() {
    // this.fetchData();
    if (localStorage.getItem("hot-token")) {
      this.hot_user = localStorage.getItem("hot-user");
      this.hot_token = localStorage.getItem("hot-token");
    }

    if (localStorage.getItem("hot-user") === "employee") {
      this.editor = "employee";
    } else if (localStorage.getItem("hot-user") === "super-admin") {
      this.editor = "super-admin";
    }else if (localStorage.getItem("hot-user") === "sub-admin") {
      this.editor = "sub-admin";
      this.getRightsDetails();
     } else if (localStorage.getItem("hot-user") === "company-admin") {
      this.editor = "company";
    } else if (localStorage.getItem("hot-user") === "manager") {
      this.editor = "manager";
    }
    if (this.editor === "super-admin" || this.editor === "sub-admin") {
      this.setDefaultFilterData();
      this.canCreate = true;
      this.canEdit = true;
      this.canDelete = true;
    } else if (this.editor === "company" || this.editor === "manager" || this.editor === "employee") {
      // View-only access for company-admin, manager, and employee
      this.canCreate = false;
      this.canEdit = false;
      this.canDelete = false;
    }
    this.fetchData();
  },
  mounted() {
    this.fetchData();
   /* const tbody = document.querySelector(".el-table__body-wrapper tbody");
    const self = this;
    Sortable.create(tbody, {
      onEnd({ newIndex, oldIndex }) {
        const targetRow = self.tableData.splice(oldIndex, 1)[0];
        self.tableData.splice(newIndex, 0, targetRow);
        self.updateTourVideoOrder();
      }
    });*/
  },
  computed: {
    rows() {
      return this.tableData.length;
    }
  },
  methods: {
    formatDate(date) {
      // Use the centralized date formatter for timezone conversion
      const { formatDateLocal } = require('@/util/dateFormatter');
      return formatDateLocal(date, 'MM-DD-YYYY');
    },
     getRightsDetails(){
       let type="Tour";
       this.$http.get("subadmin/subadmin_rights/" + type).then(resp => {
        this.canCreate=resp.data[0].permissions.indexOf("c") !== -1 ? true : false;
        this.canEdit=resp.data[0].permissions.indexOf("e") !== -1 ? true : false;
        this.canDelete=resp.data[0].permissions.indexOf("d") !== -1 ? true : false;
       });
    },

    updateTourVideoOrder() {
      this.$http
        .post(
          "employees/updateTourVideoOrder",
          {
            data: this.tableData
          },
          this.config
        )
        .then(resp => {
          this.tableData = [];

          for (let vid of resp.data) {
            let obj = {
              id: vid.id,
              order: vid.order,
              ThumbnailDemo:
                "https://player.vimeo.com/video/" + vid.vimeo_video_id,
              name: vid.name,
              Video_id: vid.vimeo_video_id,
              url: "https://lms.homeoftraining.com/#/tour?id=" + vid.tour_id,
              type: vid.type,
              status: vid.status
            };
            this.tableData.push(obj);
          }
        });
    },
    startSlide: function() {
      this.timer = setInterval(this.next, 4000);
    },
    next: function() {
      this.currentIndex += 1;
    },
    prev: function() {
      this.currentIndex -= 1;
    },
    createNotification() {
      this.$router.push("/add_new_notification");
    },
    handleEdit(rowid) {
      this.$router.push("/add_new_notification?id=" + rowid);
    },
    handleDelete(id) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn",
        cancelButtonClass: "btn greybtn",
        confirmButtonColor: "#E0E0E0",
        cancelButtonColor: "",
        confirmButtonText: "Yes",
        cancelButtonText: "No"
      }).then(result => {
        if (result.value) {
          this.$http
            .delete(
              `notification/delete/${id}`,
              this.config
            )
            .then(resp => {

              Swal.fire({
          title: "Success!",
          text: "Notification has been deleted.",
          icon: "success",
          confirmButtonClass: "btn btn-success",
          // buttonsStyling: false
              });
              this.fetchData();
            });
        }
      });
    },

    fetchData() {
      this.loading = true;
      this.$http
        .post(
          "notification/all",
          {
            search : this.searchQuery
          },
          this.config
        )
        .then(resp => {
          this.tableData = [];
          this.tableData = resp.data;
        })
        .finally(() => (this.loading = false));
      this.saveSearchData();
    },
    resetFilters() {
      this.searchQuery = "";
      this.filters.videoStatus = "";
      this.filters.videoType = "";
      this.fetchData();
    },

  }
};
</script>
<style scoped>
table {
  width: 0px !important;
}
.fade-leave-active {
  transition: all 0.9s ease;
  overflow: hidden;
  visibility: visible;
  position: absolute;
  width: 100%;
  opacity: 1;
}

.fade-enter,
.fade-leave-to {
  visibility: hidden;
  width: 100%;
  opacity: 0;
}

iframe {
  height: 400px;
  width: 100%;
}

.prev,
.next {
  cursor: pointer;
  position: absolute;
  top: 50%;
  width: auto;
  padding: 16px;
  color: white;
  font-weight: bold;
  font-size: 18px;
  transition: 0.7s ease;
  border-radius: 0 4px 4px 0;
  text-decoration: none;
  user-select: none;
  background-color: rgba(0, 0, 0, 0.9);
}

.next {
  right: 0;
}

.prev {
  left: 0;
}

.prev:hover,
.next:hover {
  background-color: rgba(0, 0, 0, 0.9);
}

.no-border-card .card-footer {
  border-top: 0;
}

.custom-size .btn-sm {
  padding: 2px !important;
  font-size: 16px !important;
}

.rounded-circle {
  border-radius: none !important;
}
table {
  width: 0px !important;
}

@media only screen and (max-width: 1024px),
  (min-device-width: 768px) and (max-device-width: 1024px) {
  .tourGrid >>> table.el-table__body td:nth-of-type(1):before {
    content: "Role";
  }
  .tourGrid >>> table.el-table__body td:nth-of-type(2):before {
    content: "Message";
  }
  .tourGrid >>> table.el-table__body td:nth-of-type(3):before {
    content: "Date";
  }
  .tourGrid >>> table.el-table__body td:nth-of-type(4):before {
    content: "Action";
  }
  /* .tourGrid >>> table.el-table__body td:nth-of-type(5):before {
    content: "Url";
  }
  .tourGrid >>> table.el-table__body td:nth-of-type(6):before {
    content: "Type";
  }
  .tourGrid >>> table.el-table__body td:nth-of-type(7):before {
    content: "Status";
  }
  .tourGrid >>> table.el-table__body td:nth-of-type(8):before {
    content: "Action";
  } */

  .vediotable .el-table__body tr td:nth-child(2) {
    height: 130px;
  }
}
</style>
